import { useEffect } from "react";
import { Search, ArrowLeft,UserCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function GalleryFeedHeader({
  // Back CTA
  backToFeedPath = "/arthouse",
  backLabel = "Back",

  // Profile CTA (more personal default)
  profileButtonLabel = "My Art Page",
  onProfileClick,
  profileDisabled = false,

  // Search
  q,
  setQ,

  // OPTIONAL: if provided by parent, we force ArtGrid mode
  showcaseView,
  setShowcaseView,
}) {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof setShowcaseView === "function" && showcaseView !== "grid") {
      setShowcaseView("grid");
    }
  }, [setShowcaseView, showcaseView]);

  return (
    <div className="w-full">
      <div className="flex items-center gap-3 flex-wrap">
        {/* Left: Back */}
        <button
          type="button"
          onClick={() => navigate(backToFeedPath)}
          className="
            h-11 px-4 rounded-full
            border border-white/10
            bg-white/[0.03]
            backdrop-blur-md
            transition
            hover:bg-white/[0.05] hover:border-white/20
            text-[11px] tracking-[0.22em] uppercase
            text-white/85
            flex items-center gap-2
          "
          aria-label="Back to ArtHouse feed"
        >
          <ArrowLeft className="h-4 w-4 text-white/70" />
          <span className="hidden sm:inline">{backLabel}</span>
        </button>

        {/* Middle: Search */}
        <div className="flex-1 min-w-[280px]">
          <div
            className="
              h-11
              flex items-center gap-2.5
              rounded-full
              border border-white/10
              bg-white/[0.035]
              backdrop-blur-xl
              px-4
              transition
              hover:border-white/20 hover:bg-white/[0.05]
              focus-within:border-emerald-300/35 focus-within:bg-white/[0.055]
            "
          >
            <Search
              className="h-4.5 w-4.5 text-white/60 shrink-0"
              aria-hidden="true"
            />

            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search art, tags, creator…"
              aria-label="Search gallery"
              className="
                w-full min-w-0
                bg-transparent
                text-[13px] text-white/90
                placeholder:text-white/40
                appearance-none
                border-0 outline-none
                ring-0 focus:ring-0
                shadow-none focus:shadow-none
              "
            />
          </div>
        </div>

        {/* Right: Controls */}
        <div className="flex items-center gap-2">
          {/* My Art Page */}
          <button
            type="button"
            onClick={onProfileClick}
            disabled={profileDisabled}
            className="
              h-11 px-4 rounded-full
              border border-white/10
              bg-white/[0.03]
              backdrop-blur-md
              transition
              hover:bg-white/[0.05] hover:border-white/20
              text-[11px] tracking-[0.18em] uppercase
              text-white/85
              disabled:opacity-50
              flex items-center gap-2
            "
            aria-label="Open my art page"
          >
            <UserCircle className="h-5 w-5 text-white/70" />
            <span className="hidden sm:inline">{profileButtonLabel}</span>
            <span className="sm:hidden">My Page</span>
          </button>

          {/* Clubs */}
          <button
            type="button"
            onClick={() => navigate("/clubs")}
            className="
              h-11 px-4 rounded-full
              border border-white/10
              bg-white/[0.03]
              backdrop-blur-md
              transition
              hover:bg-emerald-300/10 hover:border-emerald-300/35
              text-[11px] tracking-[0.18em] uppercase
              text-white/85
              flex items-center gap-2
            "
            aria-label="Go to clubs"
          >
            <span className="text-[15px] leading-none"></span>
            <span className="hidden sm:inline">Clubs</span>
          </button>
        </div>
      </div>
    </div>
  );
}
